module.exports = __webpack_public_path__ + "static/media/story_1.9ee26615.png";